import {Pipe, PipeTransform} from '@angular/core';
import {formatNumber} from "@angular/common";
import {Serializer} from '../interfaces/serializer';
import {User} from '../interfaces/user';
import {Observable} from 'rxjs';
import {selectUser} from '../store/init/init.selectors';
import {Store} from '@ngrx/store';
import {AppState} from '../store/store';
import {map} from 'rxjs/operators';

@Pipe({
  name: 'formatNumber'
})
export class FormatNumberPipe implements PipeTransform {
  private readonly _user$: Observable<Serializer<User>> = this._store.select(selectUser);

  constructor(
    private readonly _store: Store<AppState>
  ) {}

  public transform(value: number): Observable<string> {
    return this._user$.pipe(
      map((user: Serializer<User>) => formatNumber(value, user.attributes.language))
    );
  }

}
